import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as statsTypes from "../../constants/statsTypes";
import * as matchingActions from "../../actions/matchingActions";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as reducerHelper from "../../helpers/reducerHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as translationHelper from "../../helpers/translationHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.MATCHING_INIT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.MATCHING_INITIALIZED,
                        payload: {
                            initialized: true
                        }
                    },
                    matchingActions.matchingAvailable(tabId)
                ];
            }

            return [
                {
                    type: actionTypes.MATCHING_INITIALIZED,
                    payload: {
                        initialized: false
                    }
                },
                messageHelper.getWarningMessageAction("matching.cannotBeUsed")
            ];
        case handlers.MATCHING_CAN_BE_USED:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === true) {
                if (state.global.matchingProductList.length > 0) {
                    return [
                        {
                            type: actionTypes.MATCHING_AVAILABLE,
                            payload: {
                                available: true
                            }
                        }
                    ];
                }

                let responseActions = [
                    {
                        type: actionTypes.MATCHING_AVAILABLE,
                        payload: {
                            available: true
                        }
                    },
                    matchingActions.getMatchingProducts(tabId)
                ];

                for (let tab of state.navigation.tabList) {
                    if (
                        tab.scene === componentTypes.AUTO_CORRECTION_SCENE &&
                        state.matchingTab[tab.id] !== undefined &&
                        state.matchingTab[tab.id].activeProduct !== null
                    ) {
                        responseActions.push(
                            matchingActions.getMatchingColorfiles(tab.id, state.matchingTab[tab.id].activeProduct.id)
                        );
                    }
                }

                return responseActions;
            }

            return [
                {
                    type: actionTypes.MATCHING_AVAILABLE,
                    payload: {
                        available: false
                    }
                },
                messageHelper.getWarningMessageAction("matching.cannotBeUsed")
            ];
        case handlers.MATCHING_TAB_GET_FANDECK_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MATCHING_TAB_SAVE_FANDECK_LIST,
                    payload: {
                        tabId: tabId,
                        fandeckList: modelHelper.mapFandecksToObjects(response.data)
                    }
                }
            ];
        case handlers.MATCHING_TAB_GET_FANDECK_LIST_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MATCHING_TAB_SAVE_FANDECK_LIST_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        fandeckList: modelHelper.mapFandecksToObjects(response.data)
                    }
                }
            ];
        case handlers.MATCHING_TAB_GET_COLOR_LIST:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MATCHING_TAB_SAVE_COLOR_LIST,
                    payload: {
                        tabId: tabId,
                        colorList: modelHelper.mapColorsToObjects(response.data, false)
                    }
                }
            ];
        case handlers.MATCHING_TAB_GET_COLOR_LIST_WITH_OFFSET:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MATCHING_TAB_SAVE_COLOR_LIST_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        colorList: modelHelper.mapColorsToObjects(response.data, false)
                    }
                }
            ];
        case handlers.MATCHING_GET_PRODUCTS_AVAILABLE_FOR_MATCHING:
            if (!responseHelper.isGetAllProductsSimpleFormatValid(response)) {
                return [
                    {
                        type: actionTypes.MATCHING_SAVE_PRODUCT_LIST,
                        payload: {
                            tabId: tabId,
                            productList: [],
                            resultCode: response.result,
                            resultMessage: translationHelper.getMatchingErrorTranslations(
                                response.result,
                                response.msgParams
                            )
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.MATCHING_SAVE_PRODUCT_LIST,
                    payload: {
                        tabId: tabId,
                        productList: modelHelper.mapProductsToSimpleList(response.data),
                        resultCode: null,
                        resultMessage: null
                    }
                }
            ];
        case handlers.MATCHING_GET_COLOR_FILES_FOR_PRODUCT:
            if (!responseHelper.isGetColorfilesFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            const colorfileList = modelHelper.mapColorfileList(response.data);
            const colorfilesActions = [
                {
                    type: actionTypes.MATCHING_TAB_SAVE_COLORFILE_LIST,
                    payload: {
                        tabId: tabId,
                        colorfileList: colorfileList
                    }
                }
            ];

            if (colorfileList.length !== 1) {
                return colorfilesActions;
            }

            const matchingTab = reducerHelper.getTabById(state.navigation.tabList, tabId);
            if (matchingTab !== null && state.matchingTab[tabId].tabScene === componentTypes.AUTO_CORRECTION_SCENE) {
                colorfilesActions.push(matchingActions.selectCorrectionColorfile(tabId, colorfileList[0]));
            } else {
                colorfilesActions.push(matchingActions.selectColorfile(tabId, colorfileList[0]));
            }

            return colorfilesActions;
        case handlers.MATCHING_GET_COLORIFILE_DETAIL:
            if (!responseHelper.isGetColorfileDetailFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (state.matchingTab[tabId] === undefined) {
                return [];
            }

            const baseList = modelHelper.mapMatchingBasesToObjects(response.data.bases);
            const colorFileDetailActions = [
                {
                    type: actionTypes.MATCHING_SAVE_BASE_LIST,
                    payload: {
                        tabId: tabId,
                        baseList: baseList
                    }
                },
                {
                    type: actionTypes.MATCHING_SAVE_TEMPLATE_LIST,
                    payload: {
                        tabId: tabId,
                        templateList: modelHelper.mapColorfileTemplateList(response.data.templates)
                    }
                }
            ];

            if (baseList.length === 0) {
                return colorFileDetailActions;
            }

            colorFileDetailActions.push(
                matchingActions.getMatchingPackages(
                    tabId,
                    state.matchingTab[tabId].activeProduct.id,
                    baseList.map((base) => base.id)
                )
            );

            return colorFileDetailActions;
        case handlers.MATCHING_GET_PACKAGES:
            if (!responseHelper.isGetPackagesByParamsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MATCHING_SAVE_PACKAGE_LIST,
                    payload: {
                        tabId: tabId,
                        packageList: modelHelper.mapBippToObjects(response.data.packageList)
                    }
                }
            ];
        case handlers.MATCHING_GET_RESULT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.MATCHING_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: translationHelper.getMatchingErrorTranslations(
                                response.result,
                                response.msgParams
                            )
                        }
                    }
                ];
            }

            let matchingResult = modelHelper.mapMatchingResult(response.data);

            if (matchingResult.length === 0 || state.formula[tabId] === undefined) {
                return [
                    {
                        type: actionTypes.MATCHING_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: null
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MATCHING_SAVE_RESULT,
                    payload: {
                        tabId: tabId,
                        resultList: matchingResult,
                        resultCode: response.result,
                        resultMessage: null
                    }
                },
                {
                    type: actionTypes.MATCHING_TAB_SELECT_MATCHING_RESULT,
                    payload: {
                        tabId: tabId,
                        matchingResult: matchingResult[0]
                    }
                }
            ];
        case handlers.CORRECTION_GET_RESULT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.CORRECTION_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: translationHelper.getMatchingErrorTranslations(
                                response.result,
                                response.msgParams
                            )
                        }
                    }
                ];
            }

            let correctionResult = modelHelper.mapCorrectionResult(response.data);

            if (
                correctionResult === null ||
                state.formula[tabId] === undefined ||
                state.formula[tabId].formula === null
            ) {
                return [
                    {
                        type: actionTypes.CORRECTION_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: null
                        }
                    }
                ];
            }

            let correctedFormula = state.formula[tabId].formula.editColorantListWithCorrection(
                correctionResult.colorantList,
                state.settings.shotsCoef,
                state.settings.shotsName
            );
            correctedFormula.statsType = statsTypes.AUTOMATIC_CORRECTION;

            return [
                {
                    type: actionTypes.CORRECTION_SAVE_RESULT,
                    payload: {
                        tabId: tabId,
                        resultList: [correctionResult],
                        resultCode: response.result,
                        resultMessage: null
                    }
                },
                {
                    type: actionTypes.CLONE_FORMULA_DATA,
                    payload: {
                        tabId: tabId,
                        newTabId: tabId,
                        formula: correctedFormula,
                        packageCount: null
                    }
                },
                {
                    type: actionTypes.MACHINE_VALIDATE_DISPENSED_FORMULA,
                    payload: {
                        tabId: tabId,
                        formula: correctedFormula.getCorrectionVolumes(),
                        numCanDone: 0,
                        numCanTotal: 1,
                        customCan: false
                    }
                },
                {
                    type: actionTypes.RELOAD_FORMULA_META_DATA,
                    payload: {
                        tabId: tabId
                    }
                }
            ];
        case handlers.REFORMULATION_GET_RESULT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.REFORMULATION_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: translationHelper.getMatchingErrorTranslations(
                                response.result,
                                response.msgParams
                            )
                        }
                    }
                ];
            }

            let reformulateResult = modelHelper.mapReformulationResult(response.data);

            if (
                reformulateResult === null ||
                state.formula[tabId] === undefined ||
                state.formula[tabId].formula === null
            ) {
                return [
                    {
                        type: actionTypes.REFORMULATION_SAVE_RESULT,
                        payload: {
                            tabId: tabId,
                            resultList: [],
                            resultCode: response.result,
                            resultMessage: null
                        }
                    }
                ];
            }

            let reformulatedFormula = state.formula[tabId].formula.editColorantList(
                reformulateResult.colorantList,
                settings.UNIT_ML,
                state.settings.shotsCoef,
                state.settings.shotsName
            );
            reformulatedFormula.statsType = statsTypes.REFORMULATION;

            return [
                {
                    type: actionTypes.REFORMULATION_SAVE_RESULT,
                    payload: {
                        tabId: tabId,
                        resultList: [reformulateResult],
                        resultCode: response.result,
                        resultMessage: null
                    }
                },
                {
                    type: actionTypes.CLONE_FORMULA_DATA_AND_RESET,
                    payload: {
                        tabId: tabId,
                        newTabId: tabId,
                        formula: reformulatedFormula,
                        packageCount: null
                    }
                },
                {
                    type: actionTypes.MACHINE_VALIDATE_DISPENSED_FORMULA,
                    payload: {
                        tabId: tabId,
                        formula: reformulatedFormula.getColorantVolumes(),
                        numCanDone: 0,
                        numCanTotal: 1,
                        customCan: false
                    }
                },
                {
                    type: actionTypes.RELOAD_FORMULA_META_DATA,
                    payload: {
                        tabId: tabId
                    }
                }
            ];
        case handlers.MATCHING_TAB_GET_DETAIL:
            if (!responseHelper.isColorInFandeckDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let cifDataRequest = state.server.requests.find((request) => request.id === response.sequence);

            return [
                {
                    type:
                        cifDataRequest.next === null ? actionTypes.CORRECTION_SAVE_SPECTRAL_DATA : cifDataRequest.next,
                    payload: {
                        tabId: tabId,
                        result: modelHelper.mapSpectralDataToObject(
                            response.data.colorInFandeck.rgbTuple,
                            response.data.colorInFandeckData.lab,
                            response.data.colorInFandeckData.xyz,
                            response.data.colorInFandeck.rgb,
                            modelHelper.formatReflData(response.data.colorInFandeckData.reflData)
                        ),
                        cif: modelHelper.mapColorInFandeckToObject(response.data.colorInFandeck)
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
